import React from 'react';
import Slider from "react-slick";
import "./onboard-slider-style.scss";
import {useTranslation} from "react-i18next";
import {ReactComponent as LogoLoading} from 'assets/images/loading-load-sv.svg';

const OnboardSlider = () => {

    const {t} = useTranslation();

    const dataList = [
        {
            title: "PressReader",
            content: t('slider.slider1'),
            image: "./images/press-reader/pressreader-1.png"
        },
        {
            title: "PressReader",
            content: t('slider.slider2'),
            image: "./images/press-reader/pressreader-2.png"
        },
        {
            title: t('slider.title.slider3'),
            content: t('slider.slider3'),
            image: "./images/press-reader/pressreader-3.jpg"
        }
    ];

    const renderDataList = () => {
        return dataList.map((value, index) => {
            return (
                <div key={index} className="onboard-slider-div">
                    <div className="onboard-slider-element">
                        <div className="onboard-slider-gradient">
                            <p className="onboard-slider-title">{value.title}</p>
                            <p className="onboard-slider-content">{value.content}</p>
                        </div>
                        <img className="onboard-slider-img" alt="reader-img" width={'100%'}
                             src={value.image}/>
                    </div>
                    <LogoLoading className="onboard-slider-loading"></LogoLoading>
                </div>
            );
        })
    }

    let settings = {
        dots: true,
        infinite: true,
        speed: 100,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
    };
    return (
        <>
            <Slider {...settings}>
                {renderDataList()}
            </Slider>
        </>
    )
};

export default OnboardSlider;
